<template>
  <div id="contenedor">
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>


    <!-- Carga el compononte para activar modal de  ver calendario -->
    <!--<Calendario></Calendario>-->

    <!-- Carga el compononte para activar modal de  ver calendario -->
    <component :is="componentCalendar" :datos="paramsTareas" @closeCalendar="closeModalCalendar"></component>

    <!-- boton crear -->
    <v-row>
      <v-col cols="12" class="d-flex justify-end">
        <ButtonComp @click="verCalendario" :disabled="botonCalendario" textButton="ver calendario de actividades"
          iconBut="fas fa-calendar" normalButton />
      </v-col>
      <v-col cols="12" sm="3" md="2">
        <AutocompleteComp textLabel="Nivel" v-model="paramsTareas.id_nivel" :items="NivelesDirector" item-value="id"
          item-text="desc_nivel" @change="getAllGradosCoordinador(paramsTareas.id_nivel)" />
      </v-col>

      <v-col cols="12" sm="3" md="1">
        <AutocompleteComp textLabel="Grado" v-model="id_grado" :items="GradosCoor" :isDisable="inhabilitarGradoDoc"
          item-value="id" item-text="desc_grado" @change="getAllAreasCoordinador(id_grado)" />
      </v-col>
      <v-col cols="12" sm="3" md="1">
        <AutocompleteComp textLabel="Sección" v-model="id_seccion" :items="SeccionesCoor" :isDisable="inhabilitarSeccion"
          item-value="id" item-text="nombre_seccion" @change="getAllAlumnosCoordinador(id_seccion)" />

      </v-col>
      <v-col cols="12" sm="3" md="2">
        <AutocompleteComp textLabel="Estudiante" v-model="id_alumno" :items="AlumnosCoor" :isDisable="inhabilitarAlumnos"
          item-value="id" item-text="alumno" @change="getAllActividades(id_alumno, 'alumno')" />
      </v-col>

      <v-col cols="12" sm="3" md="2">
        <AutocompleteComp textLabel="Áreas" v-model="id_area" :items="AreasCoor" :isDisable="inhabilitarAreaDoc"
          item-value="id" item-text="desc_area" @change="getAllCursosCoordinador(id_area)" />
      </v-col>

      <v-col cols="12" sm="3" md="2">
        <AutocompleteComp textLabel="Curso" v-model="id_curso" :items="CursosCoor" :isDisable="inhabilitarCursoDoc"
          item-value="id" item-text="desc_curso" @change="getAllActividades(id_curso, 'curso')" />
      </v-col>
      <!-- //*************************************************************************************************** */
        //********      VERSION DE CODIGO PERU  "MERGE 17/06/2020" ****************************************** ******/ -->
      <v-col cols="12" sm="3" md="2">
        <AutocompleteComp textLabel="Periodo" v-model="elrango" :items="PeriodoCoor" item-value="rango"
          item-text="nombre_periodo" @change="obtenerRangos()" :isDisable="inhabilitarPeriodo" />
      </v-col>
    </v-row>
    <!-- fin de boton -->

    <!-- /////////////////////////////////////////////////////
            //    PANTALLA PRINCIPAL DE PROGRAMACION DOCENTE   //
        ///////////////////////////////////////////////////////////    -->

    <!-- //**************************************************************************************************** */ -->

    <v-row dense>
      <v-col cols="12">
        <ComundataTablecomp whitSearch :headers="SupervisionEstudiantesHeaders" :items="TareasCoordinacion" :search="search">

          <template v-slot:tareaAsignada="{ item }">
            <v-chip class="primary my-1"><a style="color: #fff; text-decoration: none"
                @click="download(URL_SPACE + '/' + item.ruta_actividad)">{{ item.archivo_actividad }}</a></v-chip>
          </template>
          <template v-slot:fechaEntrega="{ item }">
            <span>{{ item.fecha_actividad | fechaTransform }}-{{
              item.hora_fin_actividad | hora
            }}</span>
          </template>

          <template v-slot:comentarioDocente="{ item }">
              <v-tooltip top>
                  <template v-slot:activator="{ on }">
                      <v-row v-on="on" class="d-flex justify-center" v-if="item.observacion_docente === null || item.observacion_docente == undefined">
                          
                          <span ><v-chip color="error">Sin comentario</v-chip></span>
                          
                      </v-row>
                      <v-row v-on="on" class="d-flex justify-center" v-else>

                          <v-btn text ><v-icon color="primary">fa-comment-dots</v-icon></v-btn>
                          
                      </v-row>
                  </template>
                    <span v-if="item.observacion_docente === null || item.observacion_docente == undefined"> {{ 'El Docente no ha generado observaciones todavía' }} </span>
                    <span v-if="item.observacion_docente === ''"> {{ 'El Docente no incluyo ninguna observación al cargar la actividad' }} </span>
                    <span v-else> {{ item.observacion_docente }} </span>
              </v-tooltip>
          </template>

          <template v-slot:calificacion="{ item }">
            <span v-if="item.calificacion_revision === null">Sin calificar</span>
            <span v-else>{{ item.calificacion_revision }}</span>
          </template>

          <template v-slot:estadoTarea="{ item }">
            <v-chip :color="item.color_estado_alumno" style="color: #fff">{{
              item.desc_estado_alumno
            }}</v-chip>
          </template>

          <!-- ESTA ES LA ACTIVIDAD RESUELTA MANDADA POR EL ESTUDIANTE -->
          <template v-slot:tareaEnviada="{ item }">
            <v-chip v-if="item.archivo_alumno === null">Sin enviar</v-chip>
            <v-chip class="primary" v-else><a @click="download(URL_SPACE + '/' + item.ruta_alumno)"
                style="color: #fff; text-decoration: none">{{ item.archivo_alumno }}</a></v-chip>
          </template>

          <template v-slot:fechaEnvio="{ item }">
            <v-chip v-if="item.fecha_alumno === null">----</v-chip>
            <v-chip class="primary" v-else>
              {{ item.fecha_alumno | fecha }}</v-chip>
          </template>

          <template v-slot:comentarioAlumno="{ item }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-row v-on="on" class="d-flex justify-center" v-if="item.observacion_alumno === null || item.observacion_alumno == undefined">
                                   
                                    <span ><v-chip color="error">Sin comentario</v-chip></span>
                                   
                                </v-row>
                                <v-row v-on="on" class="d-flex justify-center" v-else>

                                    <v-btn text ><v-icon color="primary">fa-comment-dots</v-icon></v-btn>
                                    
                                </v-row>
                            </template>
                            <span v-if="item.observacion_alumno === null || item.observacion_alumno == undefined"> {{ 'El estudiante no ha generado observaciones todavía' }} </span>
                            <span v-if="item.observacion_alumno === ''"> {{ 'El estudiante no incluyo ninguna observación al cargar la actividad' }} </span>
                            <span v-else> {{ item.observacion_alumno }} </span>
                        </v-tooltip>
                    </template>
          
        </ComundataTablecomp>

      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <!-- <v-chip label class="my-2 mx-2 primary">RECIBIDAS: {{ contProgramada }}</v-chip>
        <v-chip label class="my-2 mx-2" color="#6d6d6d" dark>CREADAS: {{ contEjecutada }}</v-chip>
        <v-chip label class="my-2 mx-2 warning">POR EVALUAR: {{ contSinejecutar }}</v-chip>
        <v-chip label class="my-2 mx-2 " color="#6ABF89" dark>EVALUADAS: {{ contReprogramada }}</v-chip>
        <v-chip label class="my-2 mx-2 success">TOTAL: {{ TareasCoordinacion.length }}</v-chip> -->

        <v-col style="background-color: #f1eeee;" label >ESTADO DE LAS EVALUACIONES
                    
                    <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-chip v-on="on" class="generado-est mx-2" label dark>POR REALIZAR: {{ contEjecutada }}</v-chip>
                            </template>
                            <span> {{ `Este campo indica que al estudiante le faltan actividades por entregar` }} </span>
                    </v-tooltip>
                    <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-chip v-on="on" class="enviado-est mx-2" label dark>POR EVALUAR: {{ contSinejecutar }}</v-chip>
                            </template>
                            <span> {{ `Este campo indica que el docente todavía tiene actividades por evaluar` }} </span>
                    </v-tooltip>
                    <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-chip v-on="on" class="evaluado-est mx-2" label dark>EVALUADAS: {{ contReprogramada }}</v-chip>
                            </template>
                            <span> {{ `Este campo indica el total de actividades evaluadas por el docente` }} </span>
                    </v-tooltip>
                    <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-chip v-on="on" class="mx-2" color="primary" label dark>TOTAL: {{ TareasCoordinacion.length }}</v-chip>
                            </template>
                            <span> {{ `Este campo indica el total de actividades que se han asignado al estudiante` }} </span>
                    </v-tooltip>
                    
                    
                    
                </v-col>

      </v-col>
    </v-row>


    
  </div>
</template>


<script>
import axios, { API_URL } from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import Calendario from '../GestionCoordinacion/components/calendarioActividadesAlumnos.vue'
import { BUCKET_ORIGIN_SPACE } from '../../../helpers/axios';
import ButtonComp from '../../../components/ComponentsEst/TableButtonComp.vue';
import ComundataTablecomp from '../../../components/ComponentsEst/ComundataTablecomp.vue';
import ComunDialogComp from '../../../components/ComponentsEst/ComunDialogComp.vue';
import AutocompleteComp from '../../../components/ComponentsEst/AutocompleteComp.vue';
import { SupervisionEstudiantesHeaders } from '../../../helpers/headersTable';

export default {
  name: "tareasCoordinacion",

  components: {
    Calendario,
    ComundataTablecomp,
    ButtonComp,
    ComunDialogComp,
    AutocompleteComp
    // ModalVisorCk1,
    //ModalVisorColegio
  },

  data: (vm) => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 26, id_modulo: 7 }, //sud_modulo y modulo

    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////

    //validaciones de formulario
  

    componentCalendar: "",
    ruta_api: API_URL, // ruta del servidor
    URL_SPACE: BUCKET_ORIGIN_SPACE,

    // consulta principal
    SupervisionEstudiantesHeaders,
    // variable iniciales
    inhabilitarGradoDoc: true,
    inhabilitarAreaDoc: true,
    inhabilitarCursoDoc: true,

    filtroProgDoc: [],
    nivelDoc: [],
    gradoDocFilter: [],
    areaDocFilter: [],
    cursoDocFilter: [],

    gradoDoc: [],
    areaDoc: [],
    cursoDoc: [],
    Docentes: [],
    /////////////////////////////
    // nueva data del coordinador
    NivelesDirector: [],
    GradosCoor: [],
    AreasCoor: [],
    CursosCoor: [],
    SeccionesCoor: [],
    AlumnosCoor: [],
    PeriodoCoor: [],

    /////////////////////////////
    // nueva data del coordinador

    id_grado: null,
    id_seccion: null,
    id_alumno: null,
    id_area: null,
    id_curso: null,

    TareasCoordinacion: [],
    // parametros para generalizar las busquedas
    paramsTareas: {
      id_colegio: sessionStorage.id_colegio,
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      id_nivel: null,
      id_grado: null,
      id_area: null,
      id_curso: null,
      id_seccion: null,
      id_alumno: null,
      fecha_inicio: null,
      fecha_fin: null,
    },
    paramsProgramacion: {
      id_colegio: sessionStorage.id_colegio,
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      id_personal: null,
      id_adm_nivel: "",
      id_adm_grado: "",
      id_seccion: "",
      id_adm_area: "",
      id_adm_curso: "",
    },
    elrango: "",
    modal_reporte: false,
    contProgramada: 0,
    contReprogramada: 0,
    contSinejecutar: 0,
    contEjecutada: 0,
    contActualizada: 0,

    progDocente: [],
    search: "",
   
    /////////////////////////////////////

    // modal asociar clase
    modal_asociarClase: false,
    formTitle: "",
    asociarCl: [], // asociar Clases
    search_asociarCl: "",

    inhabilitarNivelCl: false,
    inhabilitarGradoCl: false,
    inhabilitarAreaCl: false,
    inhabilitarCursoCl: false,
    inhabilitarSeccion: true,
    inhabilitarAlumnos: true,
    inhabilitarPeriodo: true,
    botonCalendario: true,
    botonReporte: true,

    //- ck1
    tablaCk1: true,
    clases: [],
    

    //- colegio
    tablaColegio: false,
    clasesColegio: [],
    

    nivelCont: [],
    id_nivelFiltro: "",

    gradoCont: [],
    id_gradoFiltro: [],

    gradoContFilter: [],

    areaCont: [],
    areaContFilter: [],
    id_areaFiltro: [],

    cursoCont: [],
    cursoContFilter: [],
    id_cursoFiltro: [],
    ////////////////////////////////////////

    // modal programar clase
    modal_programarClase: false,
    programarCl: {
      sesion_aprendizaje: null,
      tipo_contenido: null,
      clase_virtual: null,
      fecha: "",
      id_estado: "",
    },
    programarClCopia: [],

    inhabilitarFecha: false,
    inhabilitarHoraInicio: false,
    inhabilitarHoraFin: false,
    inhabilitarSesionAprendisaje: false,
    inhabilitarClaseVirtual: false,
    inhabilitarEnlaceVirtual: false,
    inhabilitarClaseVirtualEnlace: false,
    inhabilitarObservacion: false,

    nombreArchivoSubir: "",
    archivoSubir: null,
    evento: null,

    seccionDocFilter: [],
    seccionDoc: [],
    ///////////////////////////////////

    // modal confirmacion
    dialog_delete: false,
    desc_delete: null,
    id_delete: null,
    /////////////////////////



    // modal visor de contenidos
    api_list_contenidos: [],
    tipoVisor: "",
    ///////////////////////////

    //-- funciones del date picker de fecha
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu2: false,

    menu3: false,
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),

    computedDateFormatted2() {
      return this.formatDate(this.programarCl.fecha);
    },

   
  },
  filters: {
    fecha: function (string) {
      var cadena1 = string.slice(0, -14);
      var cadena2 = cadena1.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3/$2/$1");
      return cadena2;
    },
    //-------------filtro para fechas -----------------------
    fechaTransform: function (string) {
      return string.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3/$2/$1");
    },
    //--------filtro para horas-----------------
    hora: function (hora) {
      var horaNew = parseInt(hora.substr(0, 2));
      var horaFormato = "";

      // si es pm
      if (horaNew >= 12) {
        if (horaNew == 12) {
           horaFormato = `${horaNew}:${hora.substr(3, 2)} PM`;
        } else if (horaNew > 12 && horaNew < 22) {
           horaFormato = `0${horaNew - 12}:${hora.substr(3, 2)} PM`;
        } else {
          horaFormato = `${horaNew - 12}:${hora.substr(3, 2)} PM`;
        }
      } else {
        if (horaNew == 0) {
           horaFormato = `12:${hora.substr(3, 2)} AM`;
        } else if (horaNew >= 1 && horaNew < 10) {
           horaFormato = `0${horaNew}:${hora.substr(3, 2)} AM`;
        } else {
           horaFormato = `${horaNew}:${hora.substr(3, 2)} AM`;
        }
      }

      if (!horaFormato) return null;
      //const [year, month, day] = date.split('-')
      return horaFormato;
    },
  },

  mounted() {
    this.getAllProfesores();
    //this.getAllNivelesDirectordinacion();
    this.getAllNivelesColegio();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },
    ////////////////////////////////////////////////////////

    //// modal calendario
    ...mapMutations("progDocente", ["setActivarCalendario"]),

    /////////////////////////////////////////////////////////
    // nuevas funciones de coordinador ///////////////////////
    //////////////////////////////////////////////////////////

    /*****metodo para cerrar calendario *****/
    closeModalCalendar() {
      this.componentCalendar = "";
    },

    //Metodo para traer todos los niveles sin importar el perfil
    async getAllNivelesColegio() {
      try {
        let params = {
          id_colegio: sessionStorage.id_colegio,
          id_ano_lectivo: sessionStorage.id_ano_lectivo,
        }

        const response = await axios.post('/academico/director/allniveles', params)
        this.NivelesDirector = response.data;


      } catch (e) {
        console.log(e);
      }
    },
    //// metodo para listar los grados //////////
    async getAllGradosCoordinador(id) {
      //*************************************************************************************************** */
      //********      VERSION DE CODIGO PERU  "MERGE 17/06/2020" ****************************************** */
      this.paramsTareas.id_grado = null;
      this.id_grado = null;
      this.paramsTareas.id_seccion = null;
      this.id_seccion = null;
      this.paramsTareas.id_alumno = null;
      this.id_alumno = null;
      this.paramsTareas.id_area = null;
      this.id_area = null;
      this.paramsTareas.id_curso = null;
      this.id_curso = null;
      this.paramsTareas.fecha_inicio = null;
      this.paramsTareas.fecha_fin = null;
      this.elrango = "";
      this.paramsProgramacion.id_adm_nivel = id;
      try {
        this.paramsTareas.id_nivel = id;
        const response = await axios.post(
          "/academico/coordinador/act/alu/gr/",
          this.paramsTareas
        );
        this.inhabilitarGradoDoc = false;
        this.GradosCoor = response.data;
        this.getAllPeriodoCoordinacion();

      } catch (error) {
        console.log(error);
      }
    },
    //// metodo para listar las areas //////////
    async getAllAreasCoordinador(id) {
      //*************************************************************************************************** */
      //********      VERSION DE CODIGO PERU  "MERGE 17/06/2020" ****************************************** */
      this.SeccionesCoor = [];
      this.AlumnosCoor = [];
      this.AreasCoor = [];
      this.CursosCoor = [];
      this.inhabilitarAlumnos = true;
      this.inhabilitarAreaDoc = false;
      this.inhabilitarCursoDoc = true;
      this.paramsTareas.id_grado = id;
      this.id_area = null;
      this.elrango = "";

      try {
        const response = await axios.post(
          "/academico/coordinador/act/alu/ar/",
          this.paramsTareas
        );
        this.AreasCoor = response.data;
        await this.getAllSeccionesCoordinador();
      } catch (error) {
        console.log(error);
      }
    },
    //******consultar todas los cursos del coordinador  */
    async getAllCursosCoordinador(id) {
      //*************************************************************************************************** */
      //********      VERSION DE CODIGO PERU  "MERGE 17/06/2020" ****************************************** */
      this.paramsTareas.id_curso = null;
      this.paramsTareas.id_area = id;
      this.CursosCoor = [];
      //this.paramsProgramacion.id_adm_area = id
      try {
        const response = await axios.post(
          "/academico/coordinador/act/alu/cur/",
          this.paramsTareas
        );
        this.inhabilitarCursoDoc = false;
        this.CursosCoor = response.data;
        this.getAllActividades(id, "area");

      } catch (error) {
        console.log(error);
      }
    },
    //*******  cargar las secciones del coordinador  ******/

    //*************************************************************************************************** */
    //********      VERSION DE CODIGO PERU  "MERGE 17/06/2020" ****************************************** */
    async getAllSeccionesCoordinador() {
      try {
        const response = await axios.post(
          "/academico/coordinador/act/alu/sec/",
          this.paramsTareas
        );
        this.inhabilitarSeccion = false;
        this.SeccionesCoor = response.data;

      } catch (error) {
        console.log(error);
      }
    },

    //*************************************************************************************************** */
    //********      VERSION DE CODIGO PERU  "MERGE 17/06/2020" ****************************************** */
    //******* cargar todos los alumnos ************ */
    async getAllAlumnosCoordinador(id) {
      this.paramsTareas.id_area = null;
      this.id_area = null;
      this.paramsTareas.id_curso = null;
      this.id_curso = null;
      this.paramsTareas.fecha_inicio = null;
      this.paramsTareas.fecha_fin = null;
      this.elrango = "";
      this.paramsTareas.id_seccion = id;
      //console.log('parametros------>>>'+JSON.stringify(this.paramsTareas))
      try {
        const response = await axios.post(
          "/academico/coordinador/act/alu/alum/",
          this.paramsTareas
        );
        this.AlumnosCoor = response.data;
        this.inhabilitarAlumnos = false;
      } catch (error) {
        console.log(error);
      }
    },

    //**********  cargar los periodos  **** ******/
    async getAllPeriodoCoordinacion() {
      try {
        let params = {
          id_colegio: sessionStorage.id_colegio,
          id_ano_lectivo: sessionStorage.id_ano_lectivo,
          id_nivel: this.paramsTareas.id_nivel,
        };
        const response = await axios.post(
          "/academico/coordinador/act/alu/pdo/",
          params
        );
        this.PeriodoCoor = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    //******  cargar todas las actividades  de los alumnos  *****/
    async getAllActividades(id, tipo) {
      if (tipo === "alumno") {
        this.id_area = null;
        this.id_curso = null;
        this.CursosCoor = [];
        this.paramsTareas.id_alumno = id;
        this.paramsTareas.id_area = null;
        this.paramsTareas.id_curso = null;
      } else if (tipo === "area") {
        this.paramsTareas.id_area = id;
        this.paramsTareas.fecha_inicio = null;
        this.paramsTareas.fecha_fin = null;
        this.elrango = "";
      } else if (tipo === "curso") {
        this.paramsTareas.id_curso = id;
        this.paramsTareas.fecha_inicio = null;
        this.paramsTareas.fecha_fin = null;
        this.elrango = "";
      } else if (tipo === "periodo") {
        console.log("periodos");
      }
      try {
        //this.paramsProgramacion.id_personal = id
        const response = await axios.post(
          "/academico/coordinador/act/alu/act/",
          this.paramsTareas
        );
        this.TareasCoordinacion = response.data;
        this.inhabilitarPeriodo = false;
        this.inhabilitarAreaDoc = false;
        if (this.TareasCoordinacion.length === 0) {
          this.botonCalendario = true;
          this.botonReporte = true;
        } else {
          this.botonReporte = false;
          this.botonCalendario = false;
        }
        this.reporte(this.TareasCoordinacion);
        //console.log('Las actividades:------>>>'+JSON.stringify(response.data))
      } catch (error) {
        console.log(error);
      }
    },
    /*****cargar actividades segun curso  */
    async getAllSActividadesCursos(id) {
      try {
        this.paramsProgramacion.id_adm_curso = id;
        await this.getAllActividades(this.paramsProgramacion.id_personal);
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerRangos() {
      try {
        var fechaInicio = this.elrango.substr(0, 10);
        var fechaFin = this.elrango.substr(11, 22);
        this.paramsTareas.fecha_inicio = fechaInicio;
        this.paramsTareas.fecha_fin = fechaFin;
        await this.getAllActividades(2, "periodo");
      } catch (error) {
        console.log(error);
      }
    },
    reporte(item) {
      var creadas = 0;
      var recibidas = 0;
      var evaluadas = 0;
      var porevaluar = 0;
      //this.modal_reporte = true
      for (var i = 0; i < item.length; i++) {
        switch (item[i].id_estado_actividad_alumno) {
          case 1:
            creadas = creadas + 1;
            break;
          case 2:
            porevaluar = porevaluar + 1;
            break;
          case 3:
            evaluadas = evaluadas + 1;
            break;
          case 4:
            recibidas = recibidas + 1;
            break;
          default:
            break;
        }
      }
      //var ejecutada = creadas*100/item.length;
      this.contEjecutada = creadas;
      //var programada  = recibidas*100/item.length;
      this.contProgramada = recibidas;
      // var repro = evaluadas*100/item.length;
      this.contReprogramada = evaluadas;
      //var sineje = porevaluar*100/item.length;
      this.contSinejecutar = porevaluar;
    },
    closeModalReporte() {
      this.modal_reporte = false;
      this.contSinejecutar = 0;
      this.contEjecutada = 0;
      this.contProgramada = 0;
      this.contReprogramada = 0;
    },

    ////////////////////////////////////////////////////////////
    //////////  FIN DE LOS DATOS DEL COORDINADOR   /////////////
    ////////////////////////////////////////////////////////////

    //  ------- input tipo fecha  --------
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    // cargar Docentes
    async getAllProfesores() {
      //id del colegio
      var id = sessionStorage.id_colegio;
      try {
        let response = await axios.get(
          "/administrativo/personal/profesorView/" + id + ""
        );
        this.Docentes = response.data;
        console.log(JSON.stringify(this.Profesores));
      } catch (error) {
        console.log(error);
      }
    },

    //  ------- Cargar todos los registros principales al iniciar el componente   --------
    async loadMain() {
      try {
        let params = `/periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/usuario/${this.datoLogin.id}`;
        let response = await axios.get(
          `/academico/progDocente/getQuery${params}`
        );
        let data = response.data;
        this.nivelDoc = data.payload.NivelDoc;
        this.gradoDoc = data.payload.GradoDoc;
        this.areaDoc = data.payload.AreaDoc;
        this.cursoDoc = data.payload.CursoDoc;
        this.seccionDoc = data.payload.SeccionDoc;
        this.progDocente = data.payload.ProgDocente;
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error: ${error}`,
          tiempo: null,
        });
        //console.log(error)
      }
    },

    async download(url) {
      await this.$Files['downloadFetch']({ url });
    },

    //  manejador del evento nivel de la programacion de clase
    eventNivelDoc() {
      this.inhabilitarGradoDoc = false;
      this.inhabilitarAreaDoc = true;
      this.inhabilitarCursoDoc = true;

      // filtro y cargo los valores del grado segun el nivel
      //let filtro = this.asociarCl.id_nivel

      this.gradoDocFilter = this.gradoDoc.filter(
        (el) => el.id_nivel == this.filtroProgDoc.id_nivel
      );
    },

    // manejador del evento grado de la programacion de clase
    eventGradoDoc() {
      this.inhabilitarAreaDoc = false;
      this.inhabilitarCursoDoc = true;

      this.areaDocFilter = this.areaDoc.filter(
        (el) => el.id_grado == this.filtroProgDoc.id_grado
      );
    },

    // manejador del evento area de programacion de clase
    eventAreaDoc() {
      this.inhabilitarCursoDoc = false;

      //this.cargarClases()
      // filtro y cargo los valores del los curso segun el grado
      this.cursoDocFilter = this.cursoDoc.filter(
        (el) => el.id_area == this.filtroProgDoc.id_area
      );
    },

    // manejador del evento area de programacion de clase
    eventCursoDoc() {
      this.seccionDocFilter = this.seccionDoc.filter(
        (el) => el.id_curso == this.filtroProgDoc.id_curso
      );

      //this.cargarClases()
      // filtro y cargo los valores del los curso segun el grado
      //this.cursoDocFilter = this.cursoDoc.filter(el=>el.id_area == this.filtroProgDoc.id_area)
    },

    // inicia la modal asociar clase
    asociarClase() {
      if (
        this.filtroProgDoc.id_curso == "" ||
        this.filtroProgDoc.id_curso == null
      ) {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe seleccionar un Curso`,
          tiempo: null,
        });
      } else {
        this.modal_asociarClase = true;
        this.formTitle = "Asociar Clase";
        (this.asociarCl = {
          contenidoTipo: null,
          id_nivel: "",
          id_grado: "",
          id_area: "",
          id_curso: "",
        }),
          (this.clases = []);
        this.clasesColegio = [];
        this.inhabilitarNivelCl = true;
        this.inhabilitarGradoCl = true;
        this.inhabilitarAreaCl = true;
        this.inhabilitarCursoCl = true;
      }
    },

    // carga la consultas de contenido de ck1 o del colegio segun el tipo de contenido seleccinado (ck1 o colegio)
    async cargarQueryContenido() {
      try {
        this.clases = [];
        this.asociarCl.id_nivel = "";
        this.asociarCl.id_grado = "";
        this.asociarCl.id_area = "";
        this.asociarCl.id_curso = "";

        this.inhabilitarNivelCl = false;
        this.inhabilitarGradoCl = true;
        this.inhabilitarAreaCl = true;
        this.inhabilitarCursoCl = true;

        // contenido clicken 1
        if (this.asociarCl.contenidoTipo == "1") {
          this.id_nivelFiltro = "id";
          this.id_gradoFiltro = "id";
          this.id_areaFiltro = "id";
          this.id_cursoFiltro = "id";

          this.tablaCk1 = true;
          this.tablaColegio = false;

          let response = await axios.get(
            `/academico/progDocente/getQueryContCk1`
          );
          //alert(JSON.stringify(response.data))

          this.nivelCont = response.data.NivelCkOne;
          this.gradoCont = response.data.GradoCkOne;
          this.areaCont = response.data.AreaCkOne;
          this.cursoCont = response.data.CursoCkOne;

          // contenido del colegio
        } else if (this.asociarCl.contenidoTipo == "0") {
          this.id_nivelFiltro = "id_nivel";
          this.id_gradoFiltro = "id_grado";
          this.id_areaFiltro = "id_area";
          this.id_cursoFiltro = "id_curso";

          this.tablaCk1 = false;
          this.tablaColegio = true;

          await this.cargarFiltros();

          this.asociarCl.id_nivel = this.filtroProgDoc.id_nivel;
          this.eventNivelCl();

          this.asociarCl.id_grado = this.filtroProgDoc.id_grado;
          this.eventGradoCl();

          this.asociarCl.id_area = this.filtroProgDoc.id_area;
          this.eventAreaCl();

          this.asociarCl.id_curso = this.filtroProgDoc.id_curso;
          this.cargarClases();

          /* this.programarCl.id_grado    = this.filtroProgDoc.id_grado
                        this.programarCl.id_area     = this.filtroProgDoc.id_area
                        this.programarCl.id_curso    = this.filtroProgDoc.id_curso */

          //var url = "/academico/progDocente/getQueryContColegio"
        }
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error: ${error}`,
          tiempo: null,
        });
      }
    },

    cargarFiltros() {
      this.nivelCont = this.nivelDoc;
      this.gradoCont = this.gradoDoc;
      this.areaCont = this.areaDoc;
      this.cursoCont = this.cursoDoc;
    },

    // carga las clases de los gestor de contenidos segun los filtros seleccionados
    async cargarClases() {
      try {
        this.asociarCl.periodo = this.datoLogin.id_ano_lectivo;

        // contenido clicken 1
        if (this.asociarCl.contenidoTipo == "1") {
          let response = await axios.post(
            `/academico/progDocente/getClasesCk1`,
            this.asociarCl
          );

          this.clases = response.data;

          // contenido del colegio
        } else if (this.asociarCl.contenidoTipo == "0") {
          let response = await axios.get(
            `/academico/progDocente/getContenidoColegio/colegio/${this.datoLogin.id_colegio}/nivel/${this.asociarCl.id_nivel}/grado/${this.asociarCl.id_grado}/area/${this.asociarCl.id_area}/curso/${this.asociarCl.id_curso}/usuario/${this.datoLogin.id}`
          );

          this.clasesColegio = response.data.ContenidoColegio;
        }
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error: ${error}`,
          tiempo: null,
        });
      }
    },

    //  manejador del evento nivel de la programacion de clase
    eventNivelCl() {
      this.inhabilitarGradoCl = false;
      this.inhabilitarAreaCl = true;
      this.inhabilitarCursoCl = true;
      this.clases = [];
      this.clasesColegio = [];

      // filtro y cargo los valores del grado segun el nivel
      //let filtro = this.asociarCl.id_nivel
      this.gradoContFilter = this.gradoCont.filter(
        (el) => el.id_nivel == this.asociarCl.id_nivel
      );
    },

    // manejador del evento grado de la programacion de clase
    eventGradoCl() {
      this.inhabilitarAreaCl = false;
      this.inhabilitarCursoCl = true;
      this.clases = [];
      this.clasesColegio = [];

      if (this.asociarCl.contenidoTipo == "1") {
        this.areaContFilter = this.areaCont;

        // contenido del colegio
      } else if (this.asociarCl.contenidoTipo == "0") {
        this.areaContFilter = this.areaCont.filter(
          (el) => el.id_grado == this.asociarCl.id_grado
        );
      }
    },

    // manejador del evento area de programacion de clase
    eventAreaCl() {
      this.inhabilitarCursoCl = false;

      this.clases = [];
      this.clasesColegio = [];
      //this.cargarClases()
      // filtro y cargo los valores del los curso segun el grado
      let resultFiltroCurso = this.cursoCont.filter(
        (el) => el.id_area == this.asociarCl.id_area
      );
      this.cursoContFilter = resultFiltroCurso.filter(
        (el) => el.id_grado == this.asociarCl.id_grado
      );
    },

    limpiarForm() {
      this.programarCl = {
        id: null,
        sesion_aprendizaje: null,
        tipo_contenido: null,
        titulo: "",
        sub_titulo: "",
        nombre_tema: "",
        nombre_clase: "",
        id_clase: "",
        id_nivel: "",
        id_grado: "",
        id_area: "",
        id_curso: "",
        id_seccion: "",
        fecha: "",
        hora_inicio: "",
        hora_fin: "",
        enlace_sesion: "",
        apoyo_docente_ruta: "",
        apoyo_docente_nombre: "",
        nombre_uri: "",
        clase_virtual: null,
        enlace_virtual: null,
        clase_virtual_video: "",
        enlace_virtual_video_enlace: null,
        observacion: "",
        id_estado: null,
        desc_estado: "",
        color_estado: "",
      };

      this.archivoSubir = null;

      // inhabilitar campos de porgramacion docente Agregar o editar
      this.inhabilitarFecha = false;
      this.inhabilitarHoraInicio = false;
      this.inhabilitarHoraFin = false;
      this.inhabilitarSesionAprendisaje = false;
      this.inhabilitarClaseVirtual = false;
      this.inhabilitarEnlaceVirtual = false;
      this.inhabilitarClaseVirtualEnlace = false;
      this.inhabilitarObservacion = false;

      this.$refs.formDatosProgramar.resetValidation();
    },

    // Levanta la modal para programar la clase  (agregar)
    addItem(items) {
      //alert(JSON.stringify(items))
      this.limpiarForm();

      this.programarCl.titulo = "Crear Programación de Clase";
      this.programarCl.nombre_tema = items.nombre_tema;
      this.programarCl.nombre_clase = items.nombre_clase;
      this.modal_programarClase = true;
      this.evento = "agregar";
      this.programarCl.tipo_contenido = this.asociarCl.contenidoTipo;
      this.programarCl.id_clase = items.id_clase;
      this.programarCl.sesion_aprendizaje = items.sesion;
      this.programarCl.clase_virtual = 0;
      this.programarCl.clase_virtual_video = 0;

      // parametrizacion previa de programacion docente
      this.programarCl.desc_estado = "Programada";
      this.programarCl.color_estado = "6d6d6d";
      this.programarCl.id_nivel = this.filtroProgDoc.id_nivel;
      this.programarCl.id_grado = this.filtroProgDoc.id_grado;
      this.programarCl.id_area = this.filtroProgDoc.id_area;
      this.programarCl.id_curso = this.filtroProgDoc.id_curso;
    },

    //  manejador del evento nivel de la programacion de clase
    eventNivelDocCl() {
      // filtro y cargo los valores del grado segun el nivel
      //let filtro = this.asociarCl.id_nivel
      this.gradoDocFilter = this.gradoDoc.filter(
        (el) => el.id_nivel == this.programarCl.id_nivel
      );
    },

    // manejador del evento grado de la programacion de clase
    eventGradoDocCl() {
      this.areaDocFilter = this.areaDoc.filter(
        (el) => el.id_grado == this.programarCl.id_grado
      );
    },

    // manejador del evento area de programacion de clase
    eventAreaDocCl() {
      //this.cargarClases()
      // filtro y cargo los valores del los curso segun el grado
      this.cursoDocFilter = this.cursoDoc.filter(
        (el) => el.id_area == this.programarCl.id_area
      );
    },

    // manejador del evento area de programacion de clase
    eventCursoDocCl() {
      this.seccionDocFilter = this.seccionDoc.filter(
        (el) => el.id_curso == this.programarCl.id_curso
      );

      //this.cargarClases()
      // filtro y cargo los valores del los curso segun el grado
      //this.cursoDocFilter = this.cursoDoc.filter(el=>el.id_area == this.programarCl.id_area)
    },

    // botos para visualizar clases de la programacion de contenido
    gestionContenido() {
      this.setEnviarMens({
        tipo: "W",
        mensaje: `Modulo en Construccion por el Ing. Jose Guardia  `,
        tiempo: null,
      });
    },

    // replicar la clase del docente ya programada
    async replicarClase(items) {
      await this.limpiarForm();

      this.gradoDocFilter = this.gradoDoc.filter(
        (el) => el.id_nivel == items.id_nivel
      );
      this.areaDocFilter = this.areaDoc.filter(
        (el) => el.id_grado == items.id_grado
      );
      this.cursoDocFilter = this.cursoDoc.filter(
        (el) => el.id_area == items.id_area
      );
      this.seccionDocFilter = this.seccionDoc.filter(
        (el) => el.id_curso == items.id_curso
      );

      // asignacion de variables de replicación
      this.programarCl.titulo = "Replicar Programación de clase";
      this.programarCl.nombre_tema = items.nombre_tema;
      this.programarCl.nombre_clase = items.nombre_clase;
      this.modal_programarClase = true;
      this.evento = "agregar";
      this.programarCl.tipo_contenido = items.tipo_contenido;
      this.programarCl.desc_estado = items.desc_estado;
      this.programarCl.color_estado = items.color_estado;

      //asociarCl.contenidoTipo
      this.programarCl.id_clase = items.id_clase;
      this.programarCl.sesion_aprendizaje = items.sesion;
      this.programarCl.id_nivel = items.id_nivel;
      this.programarCl.id_grado = items.id_grado;
      this.programarCl.id_area = items.id_area;
      this.programarCl.id_curso = items.id_curso;

      this.programarCl.clase_virtual = 0;
      this.programarCl.clase_virtual_video = 0;
      /* this.programarCl.clase_virtual  = items.clase_virtual
                this.programarCl.enlace_virtual = items.enlace_virtual */
    },

 

    // Levanta la modal para programar la clase  (agregar)
    editItem(items) {
      this.limpiarForm();

      this.gradoDocFilter = this.gradoDoc.filter(
        (el) => el.id_nivel == items.id_nivel
      );
      this.areaDocFilter = this.areaDoc.filter(
        (el) => el.id_grado == items.id_grado
      );
      this.cursoDocFilter = this.cursoDoc.filter(
        (el) => el.id_area == items.id_area
      );
      this.seccionDocFilter = this.seccionDoc.filter(
        (el) => el.id_curso == items.id_curso
      );

      // asignacion de variables de replicación
      this.programarCl.titulo = "Editar Programación de clase";
      this.programarCl.id = items.id;
      this.programarCl.nombre_tema = items.nombre_tema;
      this.programarCl.nombre_clase = items.nombre_clase;
      this.modal_programarClase = true;
      this.evento = "editar";
      this.programarCl.tipo_contenido = items.tipo_contenido;
      this.programarCl.uri =
        this.ruta_api + items.apoyo_docente_ruta + items.apoyo_docente_nombre;
      this.programarCl.enlace_sesion = items.enlace_virtual;

      //asociarCl.contenidoTipo
      this.programarCl.id_clase = items.id_clase;
      this.programarCl.sesion_aprendizaje = items.sesion;
      this.programarCl.id_nivel = items.id_nivel;
      this.programarCl.id_grado = items.id_grado;
      this.programarCl.id_area = items.id_area;
      this.programarCl.id_curso = items.id_curso;
      this.programarCl.id_seccion = items.id_seccion;
      this.programarCl.clase_virtual = items.clase_virtual;
      this.programarCl.enlace_virtual = items.enlace_virtual;
      this.programarCl.clase_virtual_video = items.clase_virtual_video;
      this.programarCl.clase_virtual_video_enlace =
        items.clase_virtual_video_enlace;
      this.programarCl.fecha = items.fecha;
      this.programarCl.hora_inicio = items.hora_inicio;
      this.programarCl.hora_fin = items.hora_fin;
      this.programarCl.desc_estado = items.desc_estado;
      this.programarCl.color_estado = items.color_estado;
      this.programarCl.id_estado = 5;

      // Bloquear Campos de programacion docente
      this.inhabilitarFecha = true;
      this.inhabilitarHoraInicio = false;
      this.inhabilitarHoraFin = false;
      this.inhabilitarSesionAprendisaje = false;
      this.inhabilitarClaseVirtual = false;
      this.inhabilitarEnlaceVirtual = false;
      this.inhabilitarClaseVirtualEnlace = true;
      this.inhabilitarObservacion = false;

      this.programarClCopia = items;

      this.actualizarDatos();
    },

    actualizarDatos() {
      this.programarCl.fecha = this.programarClCopia.fecha;
      this.programarCl.hora_inicio = this.programarClCopia.hora_inicio;
      this.programarCl.hora_fin = this.programarClCopia.hora_fin;
      this.programarCl.clase_virtual = this.programarClCopia.clase_virtual;
      this.programarCl.enlace_virtual = this.programarClCopia.enlace_virtual;
      this.programarCl.clase_virtual_video =
        this.programarClCopia.clase_virtual_video;
      this.programarCl.enlace_virtual_video_enlace =
        this.programarClCopia.enlace_virtual_video_enlace;
      this.archivoSubir = null;
    },

    // manejador del evento para la edición (Actualizar)
    eventActualizar() {
      // habilito todos los campos
      this.inhabilitarFecha = true;

      this.inhabilitarHoraInicio = false;
      this.inhabilitarHoraFin = false;
      this.inhabilitarSesionAprendisaje = false;
      this.inhabilitarClaseVirtual = false;
      this.inhabilitarEnlaceVirtual = false;
      this.inhabilitarClaseVirtualEnlace = false;
      this.inhabilitarObservacion = false;

      this.actualizarDatos();
    },

    // manejador del evento para la edición (reprogramar)
    eventReprogramar() {
      // habilito todos los campos

      this.inhabilitarFecha = false;
      this.inhabilitarHoraInicio = false;
      this.inhabilitarHoraFin = false;
      this.inhabilitarSesionAprendisaje = false;
      this.inhabilitarClaseVirtual = false;
      this.inhabilitarEnlaceVirtual = false;
      this.inhabilitarClaseVirtualEnlace = true;
      this.inhabilitarObservacion = false;

      this.actualizarDatos();
    },

    // manejador del evento para la edición (reprogramar)
    async eventEjecutar() {
      this.habilitarSave = true;

      // Bloquear Campos de programacion docente
      this.inhabilitarFecha = true;
      this.inhabilitarHoraInicio = true;
      this.inhabilitarHoraFin = true;
      this.inhabilitarSesionAprendisaje = true;
      this.inhabilitarClaseVirtual = true;
      this.inhabilitarEnlaceVirtual = true;
      this.inhabilitarClaseVirtualEnlace = false;
      this.inhabilitarObservacion = false;

      await this.actualizarDatos();

      // activo el video virtual
      if (
        this.programarCl.id_estado == 4 &&
        this.programarCl.clase_virtual == 1
      ) {
        this.programarCl.clase_virtual_video = 1;
      }
    },

    async saveItem() {
      //this.setEnviarMens({tipo:"W", mensaje: `Guardar Archivo`, tiempo:null})
      if (this.$refs.formDatosProgramar.validate()) {
        try {
          //let params = this.datos
          this.programarCl.periodo = this.datoLogin.id_ano_lectivo;
          this.programarCl.usuario = this.datoLogin.id;
          this.programarCl.id_colegio = this.datoLogin.id_colegio;

          var res = "";
          if (this.evento == "agregar") {
            res = await axios.post("/academico/progDocente/", this.programarCl);
          }

          if (this.evento == "editar") {
            res = await axios.put(
              "/academico/progDocente/" + this.programarCl.id,
              this.programarCl
            );
            //    var res = await axios.put("/sistema/usuarioManager/"+this.datos.id,this.datos)
          }

          this.setEnviarMens({
            tipo: res.data.messageT,
            mensaje: res.data.message,
            tiempo: null,
          });

          if (res.data.messageT == "S") {
            this.modal_programarClase = false;
            this.cargarClases();
            this.loadMain();

            // si existe un archivo se sube y se actualiza la nueva uri
            if (this.archivoSubir) {
              this.saveFile(res.data.lastInsert);
            }
          }
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      }
    },

    async saveFile(id) {
      if (!this.archivoSubir) {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe subir un archivo `,
          tiempo: null,
        });
      } else {
        try {
          let formData = new FormData();
          formData.append("subirArchivo", this.archivoSubir);
          formData.append("usuario", this.datoLogin.id);
          formData.append("colegio", this.datoLogin.id_colegio);
          formData.append("periodo", this.datoLogin.id_ano_lectivo);
          formData.append("nivel", this.programarCl.id_nivel);
          formData.append("grado", this.programarCl.id_grado);
          formData.append("seccion", this.programarCl.id_seccion);
          formData.append("curso", this.programarCl.id_curso);
          formData.append("id_programacion", id);

          await axios.post(
            "/academico/progDocente/addSesionAprendisaje",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );

          // this.setEnviarMens({tipo:response.data.messageT, mensaje: `${response.data.message}`, tiempo:null})
          this.modal_programarClase = false;
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      }
    },

    // componente de  calendario
    verCalendario() {
      console.log("activando calendario");
      this.setActivarCalendario({ periodo: "", id_docente: "" });
      this.componentCalendar = "Calendario";
    },

    // activa la modal para confirmar el borrar el registro
  

    //------------BORRAR Registro -------------
    

    // botos para visualizar clases de la programacion de contenido
  

    // funcion para cerrar modal
    cerrarVisor() {
      this.visor = false;
      this.api_list_contenidos = [];
      this.tipoVisor = "";
      //this.setCloseVisor()
    },
  },
};
</script>

